<template>
	<div>
		<personal-profile-data-view
			:editable="editable"
			:personal-data="formData.personalData"
			@edition-status="personalDataEditionStatus"
		></personal-profile-data-view>

		<formal-profile-data-view
			:editable="editable"
			:formal-data="formData.formalData"
			@edition-status="formalDataEditionStatus"
		></formal-profile-data-view>

		<address-profile-data-view
			:editable="editable"
			:address-data="formData.addressData"
			@edition-status="addressDataEditionStatus"
		></address-profile-data-view>

		<organization-profile-data-view
			:editable="editable"
			:organization-data="formData.organizationData"
			@edition-status="organizationDataEditionStatus"
		></organization-profile-data-view>

		<other-profile-data-view
			:editable="editable"
			:organization-data="formData.organizationData"
			:other-data="formData.otherData"
			@edition-status="otherDataEditionStatus"
		></other-profile-data-view>

		<hidden-profile-data-view
			v-show="formData.hiddenData && hiddenDataAccessible"
			:editable="editable"
			:hidden-data="formData.hiddenData"
			@edition-status="hiddenDataEditionStatus"
		></hidden-profile-data-view>

		<v-layout row class="mb-4">
			<v-flex xs3/>
			<v-flex xs5>
				<v-alert
					:value="showAlert"
					type="info"
					outline
				>{{alertMessage}}
				</v-alert>
			</v-flex>
		</v-layout>

		<v-layout row v-if="editable">
			<v-flex xs4/>
			<v-flex xs3>
				<v-btn block color="primary" dark class="mt-2 mb-5" @click="save">Zapisz zmiany</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import {Profile} from "../../../../api/generated/Profile";
	import PersonalProfileDataView from "./components/PersonalProfileDataView";
	import AddressProfileDataView from "./components/AddressProfileDataView";
	import FormalProfileDataView from "./components/FormalProfileDataView";
	import OrganizationProfileDataView from "./components/OrganizationProfileDataView";
	import OtherProfileDataView from "./components/OtherProfileDataView";
	import HiddenProfileDataView from "./components/HiddenProfileDataView";

	export default {
		name: "BidderProfileView",
		components: {
			HiddenProfileDataView,
			OtherProfileDataView,
			PersonalProfileDataView,
			AddressProfileDataView,
			FormalProfileDataView,
			OrganizationProfileDataView
		},

		data () {
			return {
				formData: {},
				personalDataEditable: false,
				formalDataEditable: false,
				addressDataEditable: false,
				organizationDataEditable: false,
				otherDataEditable: false,
				hiddenDataEditable: false,
				showAlert: false,
				alertMessage: ''
			};
		},

		props: {
			editable: {
				default: true,
			},
		},

		computed: {
			hiddenDataAccessible () {
				return this.roles.isAdministrator() || this.roles.isLocalAdministrator() || this.roles.isDepartmentEmployee();
			}
		},

		methods: {
			personalDataEditionStatus (status) {
				this.personalDataEditable = status;
			},

			formalDataEditionStatus (status) {
				this.formalDataEditable = status;
			},

			addressDataEditionStatus (status) {
				this.addressDataEditable = status;
			},

			organizationDataEditionStatus (status) {
				this.organizationDataEditable = status;
			},

			otherDataEditionStatus (status) {
				this.otherDataEditable = status;
			},

			hiddenDataEditionStatus (status) {
				this.hiddenDataEditable = status;
			},

			save () {
				if (this.personalDataEditable || this.formalDataEditable || this.addressDataEditable ||
					this.organizationDataEditable || this.otherDataEditable || this.hiddenDataEditable) {
					this.alertMessage = 'Aby zapisać zmiany, skończ edycję danych!';
					this.showAlert = true;
				}
				else {
					this.showAlert = false;
					Profile.putBidderProfile(this, this.prepareData(), successResponse => {
						this.formData.addressData.websiteAddress = decodeURIComponent(escape(atob(this.formData.addressData.websiteAddress)));
						this.$messagesBus.$emit("success", "Zmiany zostały pomyślnie zapisane", successResponse);
						this.refresh();
					}, errorResponse => {
						this.formData.addressData.websiteAddress = decodeURIComponent(escape(atob(this.formData.addressData.websiteAddress)));
						this.$messagesBus.$emit("error", "Nie udało się zapisać zmiany", errorResponse);
					});
					// Bidder.getValidateNip(this, this.formData.formalData.nip, this.$route.params.userId, successResponse => {
					// 	if (successResponse === true) {
					//
					// 	} else {
					// 		this.alertMessage = 'Podany numer NIP już istnieje w systemie!';
					// 		this.showAlert = true;
					// 	}
					// }, errorResponse => {
					// 	this.$messagesBus.$emit("error", "Nie udało się zwalidować numer NIP", errorResponse);
					// });
				}
			},

			prepareData () {
				this.formData.addressData.websiteAddress = btoa(unescape(encodeURIComponent(this.formData.addressData.websiteAddress)));
				return this.formData;
			},

			refresh () {
				Profile.getBidderProfile(this, this.$route.params.userId, successResponse => {
					this.formData = successResponse;
				}, errorResponse => {
					if (errorResponse.error === "access_denied") {
						this.$router.push("/forbidden");
					} else {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych profilowych", errorResponse);
					}
				});
			}
		},

		created () {
			this.refresh();
		},
	};
</script>

<style scoped>

</style>
